import { CSS_SELECTOR, useCustomCss } from '../../contexts/CustomCss';
import { Container, Icon, Label } from './CustomizeAnchor.styles';
import { FunctionalComponent, h } from 'preact';
import { SettingsIcon } from '../../assets';

type Props = {
  ariaLabel: string;
  label: string;
  onClick: () => void;
};

const CustomizeAnchor: FunctionalComponent<Props> = ({ ariaLabel, label, onClick }) => {
  const { rules } = useCustomCss(CSS_SELECTOR.LINKS);

  return (
    <Container
      data-testid="uc-customize-anchor"
      onClick={onClick}
      role="link"
      aria-label={ariaLabel}
      style={{ ...rules }}
    >
      <Icon>
        <SettingsIcon />
      </Icon>
      <Label>{label}</Label>
    </Container>
  );
};

export default CustomizeAnchor;
